import React from 'react';

interface ButtonProps {
  children?: React.ReactNode;
  label?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  variant?: 'primary' | 'secondary' | 'cta';
  size?: 'sm' | 'md' | 'lg';
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  label,
  type = 'button',
  disabled = false,
  variant = 'primary',
  size = 'md',
  onClick,
  className = '',
}) => {
  const baseClasses = 'px-4 py-2 text-base font-medium rounded-lg cursor-pointer transition-all duration-300 ease-in-out text-center focus:outline-none focus:ring-2 focus:ring-offset-2';
  
  const variantClasses = {
    primary: 'bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500',
    secondary: 'bg-gray-200 text-gray-900 hover:bg-gray-300 focus:ring-gray-500',
    cta: 'bg-gradient-to-r from-yellow-400 to-green-500 text-white font-bold shadow-lg hover:shadow-xl transform hover:scale-105 focus:ring-yellow-400 border-0',
  };
  
  const sizeClasses = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-8 py-4 text-xl',
  };
  
  const disabledClasses = disabled ? 'bg-gray-300 cursor-not-allowed text-gray-500' : '';
  
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses} ${className}`}
    >
      {label || children}
    </button>
  );
};

export default Button;
